'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const LogoDecathlonStorePinSelectedAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 61 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M40.3175 58.2511C51.908 54.0998 60.2 43.0182 60.2 30C60.2 13.4315 46.7685 0 30.2 0C13.6314 0 0.199951 13.4315 0.199951 30C0.199951 43.1671 8.68272 54.353 20.4815 58.3909C20.5454 58.4886 20.7315 58.5937 21.0578 58.7059C26.1314 60.451 30.3957 70 30.3957 70C30.3957 70 34.6598 60.451 39.7337 58.7059C40.2212 58.5382 40.3958 58.3866 40.3175 58.2511Z",
          fill: "#3643BA"
        }
      ),
      /* @__PURE__ */ jsx("circle", { cx: 30.2, cy: 30, r: 24, fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M35.6204 19C27.8569 19 18.2 27.1563 18.2 33.9161C18.2 37.4073 20.8409 39.1681 24.329 39.1681C26.8902 39.1681 29.9896 38.2168 32.9794 36.3852V22.896C32.1821 24.2824 28.4349 29.8683 25.4252 32.8434C23.8905 34.3613 22.6746 35.0191 21.6282 35.0191C20.4522 35.0191 19.8942 34.2095 19.8942 33.0053C19.8942 27.5408 28.9532 20.437 34.9527 20.437C37.4242 20.437 39.0187 21.5501 39.0187 23.7157C39.0187 25.6991 37.6933 28.1885 35.431 30.4856V34.6649C39.3775 31.4975 41.7394 27.4599 41.7394 24.2014C41.7394 20.7709 39.1084 19 35.6204 19Z",
          fill: "#3643BA"
        }
      )
    ]
  }
);
const VpLogoDecathlonStorePinSelectedAsset = forwardRef(LogoDecathlonStorePinSelectedAsset);

export { VpLogoDecathlonStorePinSelectedAsset as default };
